export default __webpack_public_path__ + "static/media/arrow-right.ef3abe91.svg";